<template>
  <div>
    <v-dialog v-model="show_report"
              scrollable
              persistent
              max-width="600"
    >
      <v-card>
        <v-card-title class="mb-5 w-100">
          <v-switch
              label="همه"
              class="ml-10"
              v-model="is_all"
              inset
          ></v-switch>
          <h4 class="mr-15">
            دریافت گزارش خرید
          </h4>

          <v-spacer></v-spacer>
          <div
              @click="show_report=false;$emit('close');"
          >
            <svg width="44" height="44" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect width="44" height="44" rx="22" class="back-btn"/>
              <path d="M28.6665 22.2285C28.6665 22.5449 28.4314 22.8064 28.1263 22.8478L28.0415 22.8535L15.5415 22.8535C15.1963 22.8535 14.9165 22.5737 14.9165 22.2285C14.9165 21.9121 15.1516 21.6506 15.4567 21.6092L15.5415 21.6035L28.0415 21.6035C28.3867 21.6035 28.6665 21.8833 28.6665 22.2285Z" fill="black"/>
              <path d="M21.024 26.8059C21.2686 27.0495 21.2695 27.4452 21.0259 27.6898C20.8045 27.9122 20.4573 27.9331 20.2122 27.7521L20.142 27.6917L15.1004 22.6717C14.8773 22.4497 14.857 22.1012 15.0395 21.8562L15.1003 21.786L20.142 16.7652C20.3866 16.5216 20.7823 16.5224 21.0259 16.767C21.2473 16.9893 21.2667 17.3366 21.0847 17.5809L21.024 17.6509L16.4273 22.2291L21.024 26.8059Z" fill="black"/>
            </svg>
          </div>
        </v-card-title>
        <v-card-text>
          <v-row v-if="!is_all">
            <v-col cols="6">
              <v-combobox
                v-model="form.location"
                :items="manage_data.locations"
                item-text="get_full_name"
                outlined
                style="border-radius: 5px "
                label="مکان"
            ></v-combobox>
            </v-col>
            <v-col cols="6">
              <v-select
                  v-model="form.format"
                  :items="['PDF', 'CSV']"
                  outlined  style="border-radius: 5px "
                  label="انتخاب فرمت"
              ></v-select>
            </v-col>

            <v-col>
              <date-picker style="color: black"
                           class="my-5 mx-5"
                           :min="new Date().toLocaleDateString('en-IR')"
                           v-model="form.date"
                           large
                           range label="انتخاب تاریخ"
              ></date-picker>
            </v-col>

          </v-row>
          <v-select
              v-else
              v-model="form.format"
              :items="['PDF', 'CSV']"
              outlined  style="border-radius: 5px "
              label="انتخاب فرمت"
          ></v-select>
        </v-card-text>
        <v-card-actions>
          <v-btn
              color="green"
              class="mr-auto mb-1 ml-1"
              block
              @click="manage_download"
              :loading="download_btn_loading"
          >
            دانلود
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>


<script>
import axios from "axios";
export default {
  name: "GetReport",
  props:['show_report', 'manage_data'],
  data: ()=>({
    key: localStorage.getItem('key'),
    is_all:false,
    form:{format:'PDF', date:[]},
    download_btn_loading:false,
  }),
  created() {
  },

  methods:{
    manage_download(){
      let url = `${this.BACKEND_LINK}/api/shop-order/download-${this.form.format.toLowerCase()}/?key=${this.key}`;
      if(this.is_all){
        this.download_btn_loading=true;
        this.download(url,
        `orders.${this.form.format.toLowerCase()}`)
      }else {
        if (this.form.location){
          url+=`&location=${this.form.location}`
        }
        if (this.form.date.length>1){
          url+=`&date=${this.form.date}`
        }
        this.download_btn_loading=true;
        this.download(url,
            `orders.${this.form.format.toLowerCase()}`)
      }
    },
    download(url, f_name){
      axios.get(url, { responseType: 'blob'})
          .then(response => {
            const blob = new Blob([response.data], { type: `application/${f_name === 'orders.pdf'?'pdf':'csv'}` })
            const link = document.createElement('a')
            link.href = URL.createObjectURL(blob)
            link.download = f_name
            link.click()
            URL.revokeObjectURL(link.href)
            this.$snotify.success( 'فایل گزارشات با موفقیت دانلود شد.','فایل گزارشات',);
            this.show_report=false;
            this.$emit('close');
          })
          .catch((errors)=>{
            console.log(errors);
            if (errors.response.status === 403){
              this.$snotify.error('شما به این قسمت دسترسی ندارید!','خطا دسترسی',)
            }else{
              this.$snotify.error( 'مشکلی در دانلود فایل ','فایل گزارشات',)
            }
          })
          .finally(()=>{
            this.download_btn_loading=false;
          })
    }
  }
}
</script>

<style scoped>

</style>
